import type { Domain } from "@xinghai/shared";
import { DOMAIN_LABEL, RUBRIC_GUIDE, SCORE_ANCHORS } from "../labels";

/** In-workbench scoring contract: anchors make 0–1 sliders reproducible between experts. */
export function RubricGuide({ domain }: { domain: Domain }) {
  return (
    <details className="xz-rubric" open>
      <summary>评分标准 · {DOMAIN_LABEL[domain]}（空白=未标，0=确有问题）</summary>
      <div className="xz-rubric__body">
        <div className="xz-rubric__anchors" aria-label="评分锚点">
          {SCORE_ANCHORS.map((a) => (
            <span key={a.value} title={a.detail}>
              <b>{a.label}</b><small>{a.detail}</small>
            </span>
          ))}
        </div>
        <table className="xz-rubric__table">
          <thead><tr><th>维度</th><th>判断锚点</th></tr></thead>
          <tbody>
            {RUBRIC_GUIDE[domain].map((row) => (
              <tr key={row.key}><th scope="row">{row.label}</th><td>{row.anchor}</td></tr>
            ))}
          </tbody>
        </table>
        <p className="gz-caption">先听完整条录音，再逐字标记；拿不准时保留空白并写备注。两位专家均标后，差值 ≤0.10 自动合并，0.10–0.25 进入讨论，&gt;0.25 或离散项冲突进入仲裁。</p>
      </div>
    </details>
  );
}
